import { Card, CardProps } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

type BlogPageWrapperProps = CardProps;

export const BlogContentWrapper = ({
  sx,
  children,
  ...props
}: BlogPageWrapperProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Card
      sx={{
        backgroundColor: colors.surface.surfContainerLowest,
        backgroundImage: "inherit",
        padding: "1rem",
        borderRadius: "1.75rem",
        maxWidth: "88vw",
        "@media (min-width: 1240px)": {
          width: "70%",
        },
        "@media (min-width: 1500px)": {
          width: "60%",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Card>
  );
};
